// src/theme/vivogolfTheme.ts
import { createTheme } from '@mui/material/styles';

const primaryMain = '#CFCD4A';

declare module '@mui/material/styles' {
    interface Theme {
        leaderBoard: {
            backgroundMode: 'video' | 'bubbles' | 'image' | 'gradient';
            videoSrc?: string;
            imageSrc?: string;
        };
    }

    interface ThemeOptions {
        leaderBoard?: {
            backgroundMode?: 'video' | 'bubbles' | 'image' | 'gradient';
            videoSrc?: string;
            imageSrc?: string;
        };
    }
}

const vivoGolfTheme = createTheme({
    palette: {
        primary: {
            main: primaryMain,
            light: '#e6e48f',  // generado automáticamente (más luminoso)
            dark: '#9c9a35',   // tono más oscuro para contraste
            contrastText: '#1A1A1A',
        },
        secondary: {
            main: '#1A1A1A',     // negro suave para contraste elegante
            light: '#333333',
            dark: '#000000',
            contrastText: '#FFFFFF',
        },
        background: {
            default: '#F7F7F2',  // tono claro cálido tipo "papel"
            paper: '#FFFFFF',
        },
        text: {
            primary: '#1A1A1A',
            secondary: '#555555'
        },
    },

    typography: {
        fontFamily: `'Roboto', 'Segoe UI', sans-serif`,
        h1: { fontWeight: 700 },
        h2: { fontWeight: 700 },
        h3: { fontWeight: 600 },
        h4: { fontWeight: 600 },
        button: {
            fontWeight: 600
        }
    },

    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '0px'
                }
            }
        },

        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: '0px',
                    boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
                }
            }
        }
    },

    leaderBoard: {
        // Cambia aquí el modo:
        // 'video' | 'bubbles' | 'image' | 'gradient'
        backgroundMode: 'bubbles',

        // Si usas 'video'
        videoSrc: '/videos/vivogolf-background.mp4',

        // Si usas 'image'
        imageSrc: '/assets/images/leaderboard-bg.jpg'
    }
});

export default vivoGolfTheme;
